import { render, staticRenderFns } from "./HotelCancellationPolicy.vue?vue&type=template&id=7ec12ac8&"
import script from "./HotelCancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./HotelCancellationPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HotelCancellationPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports